export const LANGUAGE_LIST = ["hu", "en"];
